function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.3
}, React.createElement("path", {
  d: "M18.3504 16.15C18.3504 17.0613 17.6116 17.8 16.7003 17.8C15.7891 17.8 15.0503 17.0613 15.0503 16.15C15.0503 15.2387 15.7891 14.5 16.7003 14.5C17.6116 14.5 18.3504 15.2387 18.3504 16.15Z",
  fill: "#6F62FF"
}), React.createElement("path", {
  d: "M16.7002 24.125C18.6692 24.125 20.9022 24.862 21.8263 25.5H11.5742C12.4982 24.862 14.7312 24.125 16.7002 24.125Z",
  fill: "#6F62FF"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.7 19.9998C18.823 19.9998 20.55 18.2728 20.55 16.1498C20.55 14.0268 18.823 12.2998 16.7 12.2998C14.577 12.2998 12.85 14.0268 12.85 16.1498C12.85 18.2728 14.577 19.9998 16.7 19.9998ZM16.7 14.4998C17.613 14.4998 18.35 15.2368 18.35 16.1498C18.35 17.0628 17.613 17.7998 16.7 17.7998C15.787 17.7998 15.05 17.0628 15.05 16.1498C15.05 15.2368 15.787 14.4998 16.7 14.4998ZM16.7 21.9248C14.126 21.9248 9 23.2118 9 25.7748V27.6999H24.4V25.7748C24.4 23.2118 19.274 21.9248 16.7 21.9248ZM11.574 25.4998C12.498 24.8618 14.731 24.1248 16.7 24.1248C18.669 24.1248 20.902 24.8618 21.826 25.4998H11.574ZM24.444 21.9908C25.7201 22.9148 26.6001 24.1468 26.6001 25.7748V27.6999H31.0001V25.7748C31.0001 23.5528 27.1501 22.2878 24.444 21.9908ZM23.3 19.9998C25.4231 19.9998 27.1501 18.2728 27.1501 16.1498C27.1501 14.0268 25.4231 12.2998 23.3 12.2998C22.706 12.2998 22.156 12.4428 21.65 12.6848C22.343 13.6638 22.75 14.8628 22.75 16.1498C22.75 17.4368 22.343 18.6358 21.65 19.6148C22.156 19.8568 22.706 19.9998 23.3 19.9998Z",
  fill: "#6F62FF"
});

var SvgUsers = function SvgUsers(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/users.7bda69d7.svg";
export { ForwardRef as ReactComponent };